import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import useModalContext from "./useModalContext";
import classes from "./Modal.module.css";
import useIsMobile from "../../hooks/useIsMobile";

/*
 *
 * Created on Thu 04 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

function Modal({
  backdropColor = "rgb(98 94 92 / 26%)",
  width = "90%",
  height = "fit-content",
  borderRadius = 9,
  backgroundColor = "#FFFFFF",
  margin = 54,
  padding = "16px",
  maxWidth = 768,
  id,
  style = {},
  clickHandler = () => {},
  ...rest
}) {
  const modalContext = useModalContext();
  const [mounted, setMounted] = useState(false);
  const isMobile = useIsMobile({ breakpoint: 625 });

  useEffect(() => {
    if (modalContext.show) showModal();
    else hideModal();
  }, [modalContext.show]);

  const showModal = () => {
    setMounted(true);
    if (document.getElementById("overlay")) {
      document.getElementById("overlay").style.visibility = "visible";
    }
  };

  const hideModal = () => {
    setMounted(false);
    if (document.getElementById("overlay")) {
      document.getElementById("overlay").style.visibility = "hidden";
    }
    setTimeout(() => {
      modalContext.setBodyWithFooter(null);
    }, 200);
  };

  // useEffect(() => {
  //   if (document.getElementById("overlay")) {
  //     document.getElementById("overlay").style.visibility = "visible";
  //   }

  //   return () =>
  //     (document.getElementById("overlay").style.visibility = "hidden");
  // }, []);

  // useEffect(() => {
  //   return () => {
  //     setMounted(false);
  //     if (document.getElementById("overlay")) {
  //       document.getElementById("overlay").style.visibility = "hidden";
  //     }
  //   };
  // });

  const handleBackdropClick = e => {
    if (e.target !== e.currentTarget) {
      return;
    }
    modalContext.onBackdropClick();
    e.stopPropagation();
  };

  return mounted
    ? createPortal(
        <div
          className="overlay_ooredoo"
          id={id ? id + "_overlay" : undefined}
          style={{
            display: "flex",
            alignItems: "center",
            boxSizing: "border-box",
            position: "fixed",
            fontSize: "0.875rem",
            top: 0,
            zIndex: 1060,
            width: "100%",
            height: "100%",
            backgroundColor: backdropColor,
            overflow: "auto",
            padding: "20px",
          }}
          onClick={handleBackdropClick}
        >
          <div
            className={classes.modalBody}
            style={{
              height,
              backgroundColor,
              borderRadius,
              padding: padding,
              width: isMobile ? "100%" : `calc(${width} - ${2 * padding}px)`,
              maxWidth: `calc(${maxWidth}px - ${2 * padding}px)`,
              margin: "auto",
              overflow: "auto",
              ...style,
            }}
          >
            {modalContext.closeIconVis && (
              <div
                className={classes.closeIcon}
                onClick={() => modalContext.setShow(false)}
              ></div>
            )}

            {modalContext.bodyWithFooter}
          </div>
        </div>,
        document.getElementById("overlay")
      )
    : null;
}
export default Modal;
